var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 23.5,
    height: 15.5,
    rx: 1.75,
    fill: "white",
    stroke: "#F5F5F5",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_244_33435",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 23.5,
    height: 15.5,
    rx: 1.75,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_244_33435)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 16L24 16V7.46667H10.6667L11.4286 8.00001L0 16Z",
    fill: "#DD1C34"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 7.46667H10.6667L0 0H24V7.46667Z",
    fill: "#0D4BC3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.7145 3.19997C2.03009 3.19997 2.28592 2.96119 2.28592 2.66663C2.28592 2.37208 2.03009 2.1333 1.7145 2.1333C1.3989 2.1333 1.14307 2.37208 1.14307 2.66663C1.14307 2.96119 1.3989 3.19997 1.7145 3.19997ZM8.57164 8.5333C8.88723 8.5333 9.14307 8.29452 9.14307 7.99996C9.14307 7.70541 8.88723 7.46663 8.57164 7.46663C8.25605 7.46663 8.00021 7.70541 8.00021 7.99996C8.00021 8.29452 8.25605 8.5333 8.57164 8.5333ZM2.28592 13.3333C2.28592 13.6279 2.03009 13.8666 1.7145 13.8666C1.3989 13.8666 1.14307 13.6279 1.14307 13.3333C1.14307 13.0388 1.3989 12.8 1.7145 12.8C2.03009 12.8 2.28592 13.0388 2.28592 13.3333ZM3.88485 9.06126L2.90683 10.4636L3.27774 8.8265C3.21805 8.781 3.16339 8.72998 3.11464 8.67427L1.36055 9.02046L2.8631 8.10764C2.8593 8.07223 2.85735 8.03631 2.85735 7.99997C2.85735 7.96362 2.8593 7.9277 2.8631 7.89229L1.36055 6.97948L3.11463 7.32566C3.16339 7.26995 3.21805 7.21893 3.27774 7.17343L2.90683 5.53629L3.88484 6.93867C3.92278 6.93512 3.96127 6.9333 4.00021 6.9333C4.03915 6.9333 4.07764 6.93512 4.11557 6.93867L5.09359 5.53629L4.72268 7.17343C4.78237 7.21893 4.83703 7.26995 4.88578 7.32566L6.63987 6.97948L5.13732 7.89229C5.14112 7.9277 5.14307 7.96362 5.14307 7.99997C5.14307 8.03631 5.14112 8.07223 5.13732 8.10764L6.63987 9.02046L4.88578 8.67427C4.83703 8.72998 4.78236 8.781 4.72268 8.8265L5.09359 10.4636L4.11557 9.06126C4.07763 9.06481 4.03915 9.06663 4.00021 9.06663C3.96127 9.06663 3.92278 9.06481 3.88485 9.06126Z",
    fill: "#FDD64D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPh);
export default __webpack_public_path__ + "static/media/PH.3971d18096ee4fe5103e73a1edf656da.svg";
export { ForwardRef as ReactComponent };